import React from 'react';
import Button from './Button';
import  useScrollToTop from './useScrollToTop';
import villaOverviewImage from '../img/elevation_img_25.avif'; // Replace with your actual image
import groundFloorPlan from '../img/img_floorplan_3.avif'; // Replace with your actual image
import firstFloorPlan from '../img/img_floorplan_2.avif';  // Replace with your actual image
import interiorLivingRoom from '../img/living_room_img_1.avif'; // Replace with your actual image
import villaExterior from '../img/px_img.avif'; // Replace with your actual image
import './ProjectStyles.css';
// import locationMap from '../img/patna_location.png'; // Replace with an image of the location if needed

const SouthFacingHousePlan = () => {
  useScrollToTop();
  return (

    <div className='project-container'> {/* Using the general project container style */}
      <h2>South Facing 50x60 2 Storey House Plan</h2>
      <img className='project-image' src={villaOverviewImage} alt="South Facing House Overview" loading="lazy" />
      <div className='project-details'>
        <p>Discover a thoughtfully designed two-story house plan perfectly oriented on a 50x60 sqft plot to embrace the benefits of a south-facing aspect. This design prioritizes natural light, ventilation, and comfortable living across both floors, ideal for the climate of Patna, Bihar.</p>

        <h3>Design Philosophy: South-Facing Advantage</h3>
        <p>The core of this design is to leverage the south-facing orientation for optimal natural light penetration throughout the day. This not only brightens the interiors but also offers potential for passive solar heating during the cooler months. Cross-ventilation is a key consideration, ensuring a comfortable and healthy living environment.</p>

        <h3>Inspiration for Comfortable Living</h3>
        <div className='inspiration-gallery'>
          {/* Replace these with actual image paths that resonate with a comfortable family home */}
          <img src='../img/family_room_inspiration_1.jpg' alt='Comfort Inspiration 1' className='project-image' />
          <img src='../img/bright_interior_inspiration_2.jpg' alt='Comfort Inspiration 2' className='project-image' />
          <img src='../img/ventilated_space_inspiration_3.jpg' alt='Comfort Inspiration 3' className='project-image' />
          {/* Add more inspiration images as needed */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Detailed Floor Plans: Envision Your Living Spaces</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan (Approx. 3000 sqft)</h4>
          <img className='project-image' src={groundFloorPlan} alt="Ground Floor Plan" loading="lazy" />
          <p>The ground floor is designed for seamless flow and functionality. Key features typically include a welcoming entrance, a spacious south-facing living room, a well-ventilated kitchen with a dining area, and potentially a guest bedroom or a study. Thoughtful placement of windows ensures ample natural light and cross-ventilation.</p>
          <ul>
            <li><strong>Spacious Living Room (South Facing for maximum light)</strong></li>
            <li><strong>Well-Designed Kitchen with Dining Area</strong></li>
            <li><strong>Guest Bedroom/Study Option</strong></li>
            <li><strong>Common Bathroom</strong></li>
            <li><strong>Provision for Staircase to the First Floor</strong></li>
            <li>Potential for a small lawn or garden at the front (South)</li>
          </ul>
          {/* You could add more specific details about room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan (Approx. 2000 sqft)</h4>
          <img className='project-image' src={firstFloorPlan} alt="First Floor Plan" loading="lazy" />
          <p>The first floor is typically dedicated to private living spaces, including the master bedroom with an ensuite bathroom and balcony (ideally south-facing), and additional bedrooms with attached or common bathrooms. A family lounge area is also a common feature, providing a comfortable space for relaxation.</p>
          <ul>
            <li><strong>Master Bedroom with Ensuite Bathroom and Balcony (South Facing)</strong></li>
            <li><strong>2-3 Additional Bedrooms</strong></li>
            <li><strong>Attached/Common Bathrooms</strong></li>
            <li><strong>Family Lounge/Living Area</strong></li>
            <li>Potential for a terrace or balcony</li>
          </ul>
          {/* Add more specific details about room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Breakdown (Approximate)</h4>
          <ul>
            <li><strong>Ground Floor:</strong> 1800 - 2000 sqft (depending on design)</li>
            <li><strong>First Floor:</strong> 1500 - 1800 sqft (depending on design and balconies)</li>
            <li><strong>Total Built Area:</strong> ~3300 - 3800 sqft</li>
            <p>*Note: These are approximate figures and can vary based on the specific architectural design and inclusions.</p>
          </ul>
        </div>
      </div>

      <div className='project-details'>
        <h3>Comfortable Interiors: Light, Space, and Functionality</h3>
        <div className='interior-feature'>
          <h4>Naturally Lit Living Spaces</h4>
          <img className='project-image' src={interiorLivingRoom} alt="Naturally Lit Living Area" loading="lazy" />
          <p>The design emphasizes large windows and openings, particularly on the south facade, to flood the living areas with natural light, creating a warm and inviting atmosphere.</p>
        </div>

        <div className='interior-feature'>
          <h4>Optimized Ventilation</h4>
          <p>Strategic placement of windows and doors ensures excellent cross-ventilation, crucial for the climate in Patna, helping to keep the interiors cool and fresh.</p>
        </div>

        <div className='interior-feature'>
          <h4>Flexible Room Layouts</h4>
          <p>The floor plans offer flexibility to adapt to your family's needs, with options for guest rooms, home offices, or additional living spaces as required.</p>
        </div>

        {/* Add more interior features relevant to a family home */}
      </div>

      <div className='project-details'>
        <h3>Practical Exterior: Durability and Aesthetics</h3>
        <img className='project-image' src={villaExterior} alt="House Exterior" loading="lazy" />

        <div className='exterior-feature'>
          <h4>South-Facing Facade Design</h4>
          <p>The south-facing elevation is designed not only for aesthetics but also to maximize sunlight capture while considering shading elements to mitigate excessive heat during peak summer months in Patna. This might include strategically placed balconies or overhangs.</p>
        </div>

        <div className='exterior-feature'>
          <h4>Durable Materials</h4>
          <p>The exterior will be designed with durable and weather-resistant materials suitable for the local climate, ensuring longevity and low maintenance.</p>
        </div>

        {/* Add more exterior features */}
      </div>

      <div className='project-details'>
        <h3>Quality Considerations for Your Home</h3>
        <div className='materials-list'>
          <h4>Material Considerations</h4>
          <ul>
            <li><strong>Structure:</strong> Reinforced Concrete (designed for seismic considerations in the region)</li>
            <li><strong>Exterior Walls:</strong> Brick masonry with appropriate plastering and weather-resistant paint</li>
            <li><strong>Roofing:</strong> RCC slab with waterproofing and insulation to combat heat</li>
            <li><strong>Windows and Doors:</strong> UPVC or Aluminum frames with consideration for heat insulation and security</li>
            <li><strong>Flooring:</strong> Durable and easy-to-maintain options like vitrified tiles or marble</li>
            <li><strong>Consideration for Heat Mitigation:</strong> Options for reflective paint, shading devices, and insulation to manage the hot climate of Patna.</li>
          </ul>
        </div>

        {/* Add a section for Vaastu considerations if relevant to your target audience in Patna */}
        {/* <h4>Vaastu Shastra Considerations (Optional)</h4>
        <p>This plan can be adapted to incorporate Vaastu Shastra principles to ensure harmony and positive energy flow within the home. Considerations for orientation of rooms, entrances, and other elements can be integrated into a customized design.</p> */}
      </div>

      {/* Optional: Location and Context - Tailor this if you have specific location details in Patna */}
      {/* <div className='project-details'>
        <h3>Ideally Located in [Specific Area of Patna]</h3>
        {locationMap && <img className='project-image' src={locationMap} alt="Location Map" />}
        <p>This house plan is ideal for a plot in a residential area of Patna, offering a comfortable and convenient lifestyle.</p>
        <div className='location-details'>
          <h4>Local Considerations</h4>
          <ul>
            <li>Designed to suit the typical plot sizes and orientations found in Patna.</li>
            <li>Consideration for local building regulations and material availability.</li>
          </ul>
        </div>
      </div> */}

      <div className='project-details'>
        <h3>Ready to Build Your Dream Home?</h3>
        <p>This 50x60 south-facing two-story house plan provides a solid foundation for creating a comfortable and well-lit home for your family in Patna. Contact experienced architects and engineers to customize this plan to your specific needs and local building codes.</p>
        {/* Add your contact information or links to architectural services here */}
        <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Discuss Your Custom Design</Button>
                </a> {/* Using the general button style */}
      </div>
    </div>
  );
};

export default SouthFacingHousePlan;